import React, { useEffect, useState } from "react";
// import logo from './logo.svg';
import "./Instruction.scss";
import GreenButton from "../Components/GreenButton";
import InitialFooter from "../Components/InitialFooter";
import logo from "../Images/ge-healthcare-logo-white.png";
import fetchCsv from "../Controllers/FetchQuestionsTable";
import ModalCover from "../Components/ModalCover";
import ModelWaitingDisplay from "../Components/ModelWaitingDisplay";
import { useNavigate } from "react-router";
import viewNavigate from '../Utils/viewNavigate'
import useIdle from "../Hooks/useIdle";
const Instruction = (props) => {
  const isIdle = useIdle();
  let navigate = useNavigate();
  const [displayLoading, setDisplayLoading] = useState(true);
  useEffect(() => {
    fetchCsv()
      .then((table) => {
        console.log(table);
        props.setOnlineData(table);
        setDisplayLoading(false);
      })
      .finally(() => {
        setDisplayLoading(false);
      })
      .catch(() => {
        viewNavigate(navigate, "/",{viewTransition:true});
      });
  }, []);
  return (
    <>
      {displayLoading && (
        <ModalCover>
          <ModelWaitingDisplay />
        </ModalCover>
      )}
      <div className="holder-instruction">
        <div className="container-instruction">
          <ul className="rules">
            <li>Choose a category.</li>
            <li>Answer <b>3 questions</b> correctly to earn points.</li>
            <li>You have <b>30 seconds</b> for each question.</li>
            <li>The faster you answer, the higher your score.</li>
            <li>Wrong answers will lower your score.</li>
            <li>Skipping a question means no points are added.</li>
            <li>Collect points and climb the leaderboard!</li>
          </ul>
          <GreenButton onClick={()=>{viewNavigate(navigate, '/CategorySelection',{viewTransition:true})}}>Got It. Let’s Play!</GreenButton>
          <InitialFooter logo={logo}></InitialFooter>
        </div>
      </div>
    </>
  );
};
export default Instruction;
